import { Box, Container, Paper } from "@mui/material";
import { FC } from "react";
import CreateResourceGroup from "./resource-group/CreateResourceGroup";

interface ResourceGroupProps {
	arn: string;
	resourcesSelected: string[];
	regionsSelected: string[];
	changeTab: (
		index: number,
	) => void;
}

const ResourceGroup: FC<ResourceGroupProps> =({
	arn,
	resourcesSelected,
	regionsSelected,
	changeTab
}: ResourceGroupProps) => {

	return (
		<Container maxWidth="lg" component={Paper}>
			<Box sx={{ flexGrow: 1, pb: 2 }}>
				<Box sx={{ width: "100%" }}>
					<CreateResourceGroup
						arn={arn}
						resourcesSelected={resourcesSelected}
						regionsSelected={regionsSelected}
						changeTab={changeTab}
					/>
				</Box>
			</Box>
		</Container>
	);
};

export default ResourceGroup;